import { useCallback } from 'react'

export const useSmoothScroll = () => {
  return useCallback((targetId) => {
    const element = document.querySelector(targetId)
    if (element) {
      const navbarHeight = 80 // Adjust based on your navbar height
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - navbarHeight

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }, [])
}
